<template>
  <!--<button class="buttonload" :disabled="loading">
    <i v-if="loading" class="ml-1 fa fa-spinner fa-spin"></i>
    <slot>Submit</slot>
  </button>-->
  <clip-loader
    :loading="loading"
    color="white"
    :size="size"
    class="mr-1"
  ></clip-loader>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false
    }
  },
  watch: {
    loading() {}
  },
  methods: {
    // handleClick() {
    //   this.$emit('onBtnClick');
    // },
  }
};
</script>

<style scoped>

/*.buttonload {*/
/*  padding: 12px 24px; !* Some padding *!*/
/*  font-size: 16px; !* Set a font-size *!*/
/*}*/

.buttonload:disabled {
  pointer-events: stroke;
  cursor: not-allowed;
}

.buttonload i {
  margin-left: -12px;
  margin-right: 8px;
}


</style>
